import {
  HomeOutlined,
  UserOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  InfoCircleOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  AccountBookOutlined,
} from '@ant-design/icons';
export const roleTree = [
  {
    key: 'all',
    title: '管理员',
    children: [],
    label: '系统设置',
    icon: <SettingOutlined />,
    menuChildren: [
      { key: 'adminlist', label: '固全员工管理', path: '/adls' },
      { key: 'adminlist1', label: '固全用户管理', path: '/adls1' },
    ],
  },
  {
    key: '5',
    title: '查看添加投资管理',
    label: '投资管理',
    icon: <SettingOutlined />,
    path: '/tzgl',
    children: [],
  },
  {
    key: 'zxgl',
    title: '资信管理',
    children: [
      { key: 'zxgla', title: '查看企业证书管理' },
      { key: 'zxglaa', title: '管理企业证书管理' },
      { key: 'zxglb', title: '查看员工证书管理' },
      { key: 'zxglbb', title: '管理员工证书管理' },
      { key: 'zxglc', title: '查看证书使用' },
      { key: 'zxglcc', title: '管理证书使用' },
      { key: 'sbzmwj', title: '查看社保证明文件' },
      { key: 'sbzmwjm', title: '管理社保证明文件' },
      { key: 'ryzs', title: '查看荣誉证书' },
      { key: 'ryzsm', title: '管理荣誉证书' },
      { key: 'zxgld', title: '查看文件模板管理' },
      { key: 'zxgldd', title: '管理文件模板管理' },
      { key: 'ptba', title: '查看平台备案' },
      { key: 'ptbam', title: '管理平台备案' },
      { key: 'rlzy', title: '查看人力资源台账' },
      { key: 'rlzym', title: '管理人力资源台账' },
    ],
  },
  {
    key: 'zhwlb',
    title: '账号网络部',
    children: [
      { key: 'zhwlba', title: '查看财务账号' },
      { key: 'zhwlbaa', title: '管理财务账号' },
      { key: 'zhwlbb', title: '查看公司内部账号' },
      { key: 'zhwlbbb', title: '管理公司内部账号' },
      { key: 'zhwlbc', title: '查看合作单位账号' },
      { key: 'zhwlbcc', title: '管理合作单位账号' },
      { key: 'zhwlbd', title: '查看特种作业账号' },
      { key: 'zhwlbdd', title: '管理特种作业账号' },
      { key: 'zhwlbe', title: '查看其它账号' },
      { key: 'zhwlbee', title: '管理其它账号' },
    ],
  },
  {
    key: 'gqjy',
    title: '固全经营',
    children: [
      { key: 'gqjya', title: '查看项目信息管理' },
      { key: 'gqjyaa', title: '管理项目信息管理' },
      { key: 'xmtza', title: '查看项目信息台账' },
      { key: 'xmtzaa', title: '管理项目信息台账' },
      { key: '1b', title: '查看投标授权统计' },
      { key: '1bb', title: '管理投标授权统计' },
      { key: '1c', title: '查看开标提示' },
      { key: '1cc', title: '管理开标提示' },
      { key: '1d', title: '查看标书派单表' },
      { key: '1dd', title: '管理标书派单表' },
      { key: 'zssy', title: '查看证书使用' },
      { key: 'zssym', title: '管理证书使用' },
      { key: '1f', title: '查看中标项目统计' },
      { key: '1ff', title: '管理中标项目统计' },
      { key: '1g', title: '查看公司业绩' },
      { key: '1gg', title: '管理公司业绩' },
      { key: 'tsz', title: '查看特设证' },
      { key: 'tszm', title: '管理特设证' },
      
      { key: 'tbsc', title: '上传投标文件' },
    ],
  },
  {
    key: 'spzx',
    title: '审批中心',
    children: [
      { key: 'xmxxsp1', title: '项目信息审核1' },
      { key: 'xmxxsp2', title: '项目信息审核2' },
      { key: 'xmxxsp3', title: '项目信息批准' },

      { key: 'bssh1', title: '标书审核1' },
      { key: 'bssh2', title: '标书审核2' },
      { key: 'bssh3', title: '标书批准' },

      { key: 'cwsz1', title: '资金收款审核1' },
      { key: 'cwsz2', title: '资金收款审核2' },

      { key: 'cwzf1', title: '资金支出审核1' },
      { key: 'cwzf2', title: '资金支出审核2' },

      { key: 'cwfp1', title: '发票申请审核1' },
      { key: 'cwfp2', title: '发票申请审核2' },

    ],
  },
  
  {
    key: '2',
    title: '固全财务',
    children: [
      { key: 'cwxmxx', title: '查看项目信息'},
      { key: 'cwxmxxm', title: '管理项目信息'},
      { key: '2aa', title: '管理项目台账' },
      { key: 'ggfl', title: '管理项目实际费率'},

      { key: 'cwkm', title: '查看财务科目'},
      { key: 'cwkmm', title: '管理财务科目'},
      { key: 'cwzh', title: '查看资金账号'},
      { key: 'cwzhm', title: '管理资金账号'},
      { key: 'cwhtsk', title: '收款报账单'},
      { key: 'cwhtzf', title: '支付申请单'},
      { key: 'cwckpz', title: '款项/发票凭证管理'},
      { key: 'cwfpd', title: '发票申请单'},
      { key: 'mjxp', title: '管理进项票'},
      { key: 'qxdk', title: '取消抵扣'},

      { key: 'zqdj', title: '债权登记'},
      { key: 'zqdjxg', title: '债权登记修改'},
      { key: 'cwgczl', title: '过程资料查看'},
      { key: 'cwgczlm', title: '过程资料管理'},
      { key: '2f', title: '管理合同备忘栏' },

      { key: 'dfhk', title: '垫付还款' },
    ],
  },
  {
    key: '3',
    title: '统计中心',
    children: [
      { key: '3a', title: '查看记账中心' },
      { key: 'mtjd', title: '修改统计日期' },
      { key: '3aa', title: '管理记账中心' },
      { key: '3b', title: '查看统计中心' },
      { key: '3c', title: '查看客户资料' },
      { key: 'tjjxp', title: '查看进项票统计' },
      { key: 'tjxxp', title: '查看销项票统计' },
      { key: 'hggys', title: '查看合格供应商' },
      { key: 'gdzc', title: '查看固定资产' },
    ],
  },

  {
    key: '6',
    title: '个人中心',
    children: [],
  },
];

function flattenRoleTree(tree) {
  const result = {};

  function traverse(nodes) {
    if (!nodes || !Array.isArray(nodes)) return;
    nodes.forEach(node => {
      result[node.key] = node.title;
      if (node.children && node.children.length > 0) {
        traverse(node.children);
      }
    });
  }

  traverse(tree);
  return result;
}
export const roles = flattenRoleTree(roleTree);